module.exports = __webpack_public_path__ + "assets/53cb1d48cbbab61efd7cebc96d31a585.png";